namespace RedBullMOBILE360.CVM {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.CVM.OfferRedemptionGrid')
    export class OfferRedemptionGrid extends Serenity.EntityGrid<OfferRedemptionRow, any> {
        protected getColumnsKey() { return OfferRedemptionColumns.columnsKey; }
        protected getDialogType() { return OfferRedemptionDialog; }
        protected getIdProperty() { return OfferRedemptionRow.idProperty; }
        protected getInsertPermission() { return OfferRedemptionRow.insertPermission; }
        protected getLocalTextPrefix() { return OfferRedemptionRow.localTextPrefix; }
        protected getService() { return OfferRedemptionService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}